import './incident-unread-indicator.scss';

type IncidentUnreadIndicatorProps = {
  isRead: boolean;
};

export function IncidentUnreadIndicator({ isRead }: IncidentUnreadIndicatorProps) {
  return !isRead ? (
    <div className="incident-unread-indicator" data-testid="incident-unread-indicator" />
  ) : null;
}
